import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import LanguageSwitcher from '../components/LanguageSwitcher';
import InteractiveLogo from '../components/InteractiveLogo';

const Landing = ({ user }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="landing-container" data-testid="landing-page" style={{ position: 'relative' }}>
      <div className="landing-video-wrap" aria-hidden="true">
        <video className="landing-video" autoPlay muted loop playsInline data-testid="landing-bg-video">
          <source src="/landing-bg.webm" type="video/webm" />
          <source src="/landing-bg.mp4" type="video/mp4" />
        </video>
        <div className="landing-video-veil" />
      </div>
      <div className="landing-lang-switcher">
        <LanguageSwitcher variant="landing" />
      </div>
      <div className="landing-header">
        <InteractiveLogo user={user} />
        <p className="landing-subtitle" data-testid="landing-subtitle">
          {t('landing.subtitle')}
        </p>
      </div>

      <div className="landing-features">
        <div className="feature-card" data-testid="feature-card-1">
          <div className="feature-icon"><i className="fa-solid fa-clock"></i></div>
          <h3 className="feature-title">{t('landing.customCheckins')}</h3>
          <p className="feature-desc">{t('landing.customCheckinsDesc')}</p>
        </div>

        <div className="feature-card" data-testid="feature-card-2">
          <div className="feature-icon"><i className="fa-solid fa-bell"></i></div>
          <h3 className="feature-title">{t('landing.emergencyAlerts')}</h3>
          <p className="feature-desc">{t('landing.emergencyAlertsDesc')}</p>
        </div>

        <div className="feature-card" data-testid="feature-card-3">
          <div className="feature-icon"><i className="fa-solid fa-tower-broadcast"></i></div>
          <h3 className="feature-title">{t('landing.multiChannel')}</h3>
          <p className="feature-desc">{t('landing.multiChannelDesc')}</p>
        </div>
      </div>

      <button 
        className="cta-button" 
        onClick={() => navigate('/auth')}
        data-testid="get-started-button"
      >
        {t('landing.getStarted')}
      </button>
    </div>
  );
};

export default Landing;
